import { Injector } from "@angular/core";

export const AppConstants = {
  urls: {
    app: {
      login: "login",
    },
    api: {
      /*Live*/
        base: "https://ut.edu-man.com/ut/api/",
        reportNGUrl: "https://reports.edu-man.com/#/",
        reportUrl: "https://portal.edu-man.com/WebForms/DevExReportViewer.aspx",
        externalURL: "https://vc.edu-man.com/",

      /*Local*/
      // base: "http://192.168.1.117:4323/ut/api/",
      // reportNGUrl: "http://localhost:4200/#/",
      // reportUrl: "http://localhost:6008/WebForms/DevExReportViewer.aspx",
      // externalURL: "http://localhost:4200/",

      application: "",
    },
  },
  settings: {
    version: "4.0.0",
    appCode: "SB",
    instanceid: 21,
    instancecode: "SM022",
    dateFormat: "dd-MMM-yyyy",
    timeFormat: "HH:mm:ss",
    dateFormatforString: "DD-MMM-YYYY",
    monthDateYear: "MM/DD/YYYY",
    timeFormatforString: "hh:mm:ss A",
    timeFormatTile: "hh:mm A",
    dateAndTime: "YYYY-MM-DDTHH:mm",
    date: "MMM d, y",
    clientid: 114,
  },
  policy: {
    dateFormat: "",
    timeFormat: "",
    gridpagging: false,
    defaultcityid: 0,
    defaultctryid: 0,
    defaultstateid: 0,
  },
  injector: <Injector>{},
};



// WEBPACK FOOTER //
// ./src/app/app.constant.ts